module.exports = __webpack_public_path__ + "img/dropbox.40d81a22.png";